// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomSelect_Orion_css-1qprcsu-option__\\+c-LK{
    text-align: left;
    min-width: 95% !important; /* code added for width of dropdown */
}
.CustomSelect_Orion_css-1vr111p-option__TTRey{
    text-align: left;
    min-width: 95% !important; /* code added for width of dropdown */
}
.CustomSelect_Orion_css-1r4vtzz__sn8q\\+{
    width: 100% !important;
}
.CustomSelect_Orion_css-48ayfv__l1uHj{
    width: 100% !important;
}

/* code added for width of dropdown */
.CustomSelect_Orion_css-48ayfv__l1uHj+div {
    width: 100%;
}
.CustomSelect_Orion_css-1jllj6i-control__L6gWg{
    min-width: 95% !important;
}
.CustomSelect_Orion_css-19t9a5b-control__UxGKm{
    min-width: 95% !important;
}
.CustomSelect_Orion_css-vb64bg-control__gI7dJ:hover{
    min-width: 95% !important;
}
.CustomSelect_Orion_css-vb64bg-control__gI7dJ {
    min-width: 95% !important;
}
.CustomSelect_Orion_css-6y1x9t-control__Vb\\+Cs:hover {
    min-width: 95% !important;
}
.CustomSelect_Orion_css-6y1x9t-control__Vb\\+Cs {
    min-width: 95% !important;
}
/* code added for width of dropdown */

input{
    height: inherit
}

.CustomSelect_Orion_react-select__option__AbHe9{
    font-size: 80% !important;
}

.CustomSelect_Orion_react-select__option1__eeO7y{
    font-size: 100% !important;
}

.CustomSelect_Orion_react-select__menu-list__E5sO-{
    max-height: 150px !important;
    -webkit-overflow-scrolling:auto !important;
}

.CustomSelect_Orion_bus_filtr_btn__7SXoG{
    position: relative;
    top: 10px;
}
.CustomSelect_Orion_font-bus-head__KPiR6 {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
}
.CustomSelect_Orion_font-bus-head_a__39DGv {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
    text-align: left;
}
.CustomSelect_Orion_font-bus-head_pg__NMNs6{
    font-size: 1.25rem !important;
    color: #000;
    font-weight: 600;
}
.CustomSelect_Orion_filter_bus_icon__Ds1Nk {
    background: #fff !important;
    color: #83A4CF !important;
    padding: 0px 9px;
    font-size: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/Charginganalysis_Orion/CustomSelect_Orion.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yBAAyB,EAAE,qCAAqC;AACpE;AACA;IACI,gBAAgB;IAChB,yBAAyB,EAAE,qCAAqC;AACpE;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA,qCAAqC;;AAErC;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".css-1qprcsu-option{\n    text-align: left;\n    min-width: 95% !important; /* code added for width of dropdown */\n}\n.css-1vr111p-option{\n    text-align: left;\n    min-width: 95% !important; /* code added for width of dropdown */\n}\n.css-1r4vtzz{\n    width: 100% !important;\n}\n.css-48ayfv{\n    width: 100% !important;\n}\n\n/* code added for width of dropdown */\n.css-48ayfv+div {\n    width: 100%;\n}\n.css-1jllj6i-control{\n    min-width: 95% !important;\n}\n.css-19t9a5b-control{\n    min-width: 95% !important;\n}\n.css-vb64bg-control:hover{\n    min-width: 95% !important;\n}\n.css-vb64bg-control {\n    min-width: 95% !important;\n}\n.css-6y1x9t-control:hover {\n    min-width: 95% !important;\n}\n.css-6y1x9t-control {\n    min-width: 95% !important;\n}\n/* code added for width of dropdown */\n\ninput{\n    height: inherit\n}\n\n.react-select__option{\n    font-size: 80% !important;\n}\n\n.react-select__option1{\n    font-size: 100% !important;\n}\n\n.react-select__menu-list{\n    max-height: 150px !important;\n    -webkit-overflow-scrolling:auto !important;\n}\n\n.bus_filtr_btn{\n    position: relative;\n    top: 10px;\n}\n.font-bus-head {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n}\n.font-bus-head_a {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n    text-align: left;\n}\n.font-bus-head_pg{\n    font-size: 1.25rem !important;\n    color: #000;\n    font-weight: 600;\n}\n.filter_bus_icon {\n    background: #fff !important;\n    color: #83A4CF !important;\n    padding: 0px 9px;\n    font-size: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"css-1qprcsu-option": `CustomSelect_Orion_css-1qprcsu-option__+c-LK`,
	"css-1vr111p-option": `CustomSelect_Orion_css-1vr111p-option__TTRey`,
	"css-1r4vtzz": `CustomSelect_Orion_css-1r4vtzz__sn8q+`,
	"css-48ayfv": `CustomSelect_Orion_css-48ayfv__l1uHj`,
	"css-1jllj6i-control": `CustomSelect_Orion_css-1jllj6i-control__L6gWg`,
	"css-19t9a5b-control": `CustomSelect_Orion_css-19t9a5b-control__UxGKm`,
	"css-vb64bg-control": `CustomSelect_Orion_css-vb64bg-control__gI7dJ`,
	"css-6y1x9t-control": `CustomSelect_Orion_css-6y1x9t-control__Vb+Cs`,
	"react-select__option": `CustomSelect_Orion_react-select__option__AbHe9`,
	"react-select__option1": `CustomSelect_Orion_react-select__option1__eeO7y`,
	"react-select__menu-list": `CustomSelect_Orion_react-select__menu-list__E5sO-`,
	"bus_filtr_btn": `CustomSelect_Orion_bus_filtr_btn__7SXoG`,
	"font-bus-head": `CustomSelect_Orion_font-bus-head__KPiR6`,
	"font-bus-head_a": `CustomSelect_Orion_font-bus-head_a__39DGv`,
	"font-bus-head_pg": `CustomSelect_Orion_font-bus-head_pg__NMNs6`,
	"filter_bus_icon": `CustomSelect_Orion_filter_bus_icon__Ds1Nk`
};
export default ___CSS_LOADER_EXPORT___;
